"use client";

import { c as _c } from "react/compiler-runtime";
import { Alert, Box, Container, Grid, Link as MuiLink, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useDailyQuestionData } from "#/api";
import { DailyProblem } from "#/features/homePage/ui/DailyProblem/DailyProblem";
import { QuestionSummary } from "#/features/homePage/ui/QuestionSummary";
import { useI18nContext } from "#/shared/hooks";

/** Daily problem page content. Shared by Pages `/daily` and App Router pilot. */
export const DailyPageView: React.FC = () => {
  const $ = _c(38);
  const {
    LL
  } = useI18nContext();
  const theme = useTheme();
  const questionDataQuery = useDailyQuestionData();
  let t0;
  if ($[0] !== theme.breakpoints) {
    t0 = theme.breakpoints.between("sm", "lg");
    $[0] = theme.breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMediumScreen = useMediaQuery(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      bgcolor: "background.default",
      py: {
        xs: 8,
        md: 12
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isMediumScreen ? "lg" : "xl";
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      px: {
        xs: 2,
        sm: 3,
        md: 4
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      textAlign: "center",
      mb: 6
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontWeight: "bold",
      color: "text.primary",
      mb: 2
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== LL) {
    t6 = LL.HOME_DAILY_SECTION_TITLE();
    $[6] = LL;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <Typography variant="h4" sx={t5}>{t6}</Typography>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: "text.secondary",
      mb: 4,
      maxWidth: 560,
      mx: "auto",
      lineHeight: 1.65
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== LL) {
    t9 = LL.HOME_DAILY_SECTION_LEAD();
    $[11] = LL;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MuiLink href="https://leetcode.com/" target="_blank" rel="noreferrer" sx={{
      color: "primary.main",
      textDecoration: "none",
      fontWeight: 600,
      "&:hover": {
        textDecoration: "underline"
      }
    }}>LeetCode</MuiLink>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <Typography variant="body1" sx={t8}>{t9}{" "}{t10}</Typography>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t7) {
    t12 = <Box sx={t4}>{t7}{t11}</Box>;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== LL || $[20] !== questionDataQuery.error) {
    t13 = questionDataQuery.error ? <Alert severity="error" sx={{
      mb: 4
    }}>{LL.HOME_DAILY_QUESTION_ERROR()}</Alert> : null;
    $[19] = LL;
    $[20] = questionDataQuery.error;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      justifyContent: "center"
    };
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      xs: 12,
      lg: 8
    };
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      mb: 4,
      p: 3,
      borderRadius: 2,
      bgcolor: "background.paper",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
    };
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== questionDataQuery) {
    t17 = <Grid size={t15}><QuestionSummary questionDataQuery={questionDataQuery} sx={t16} /></Grid>;
    $[25] = questionDataQuery;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      xs: 12
    };
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== questionDataQuery) {
    t19 = <Grid size={t18}><DailyProblem questionDataQuery={questionDataQuery} /></Grid>;
    $[28] = questionDataQuery;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t17 || $[31] !== t19) {
    t20 = <Grid container={true} spacing={4} sx={t14}>{t17}{t19}</Grid>;
    $[30] = t17;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t2 || $[36] !== t20) {
    t21 = <Box sx={t1}><Container maxWidth={t2} sx={t3}>{t12}{t13}{t20}</Container></Box>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t2;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  return t21;
};